module.exports = __webpack_public_path__ + "static/media/no1.90d6e8cd.svg";